
import { Navigate } from 'react-router-dom'
import LoginScreen from '../auth/login/LoginScreen'
import AlarmManagementDashboard from '../components/alarms/AlarmsDashboard'
import ChargerPanel from '../components/chargers/ChargerPanel/ChargerPanelDashboard'
import AcChargerPanel from '../acModules/components/chargers/chargerPanel/AcChargerPanelDashboard'
import ChargingStationDashboard from '../components/chargingStation/ChargingStationDashboard'
import {
  AddCharger, ManageChargersDashboard, AlarmPanelDashboard,
  AddParameter, EditParameter, ViewParameter,
  UserForm, RoleForm, CustomerForm, RoleManagementDashboard, UserManagementDashboard,
  SetParametersDashboard,
  OrgManagementDashboard, OrgForm, EditHistory, ChargingStationEditHistory,
  ChargerLogsDashboard, ChargerHistoryDashboard, CustomerManagementDashboard, AddBulkCharger, ChargingStationForm, ExceptionLogsDashboard,
  CreateRule, UpdateCommandsDashboard,
  AddUpdateCommand,
  SpuriousChargersDashboard,
  NewDashboard,
  UsbCertificates,
  ChargerCertificatesInfo,
  CreateUsbCertificate,
  AddSoftwareVersion,
  SoftwareReleaseDashboard,
  ManageSoftwareVersionReleasesDashboard,
  ManageDeploymentLogsDashboard,
  SessionHistoryDashboard,
  UptimeReportDashboard,
  RmsSupportAIChatDashboard,
  RmsSupportAIChatBot,
  HelpAndFAQDashboard,
  HelpAndFAQTopicsDashboard,
  HelpAndFAQArticle,
  TroubleShootingDashboard,
  DocumentationDashboard,
  AddRmsSupportDocuments,
  AdvanceExecutionPlan,
  AdvanceRuleEngineForm,
  StatusHistoryDashboard,
  AdvanceRuleEngineDashboard,
  CreateChargerCertificate,
  ManageAdminPasswordUpdateLogsDashboard,
  InventoryParamReportDashboard,
  AddPlcLogConfiguration
} from '../components/componentExports'
import Dashboard from '../components/dashboard/Dashboard'
import CreateBroadcastMessage from '../components/chargers/BroadcastMessage/CreateBroadcastMessage'
import EditBroadcastMessage from '../components/chargers/BroadcastMessage/EditBroadcastMessage'
import React from 'react';
import access from '../auth/service/AccessControl'
import ConfigureNotificationDashboard from '../components/configureNotification/ConfigureNotificationDashboard'
import ViewUpdateCommand from '../components/chargers/UpdateCommands/ViewUpdateCommand'
// import localStorageInstance from '../rmsReduxStore/api-service/LocalStorageService'
// import NocMap, { dummyChargers } from '../components/nocDashboard/NocMap'
import NocDashboard from '../components/nocDashboard/NocDashboard'
import { AcChargerCertificatesInfo, AcDashboard, AcManageChargersDashboard, CreateAcChargerCertificate } from '../acModules/components/acComponentsExports'
import AcAlarmsDashboard from '../acModules/components/alarms/AcAlarmDashboard'
import AcChargerHistoryDashboard from '../acModules/components/reports/AcChargerHistoryDashboard'
import AcCustomerManagementDashboard from '../acModules/components/customerManangement/AcCustomerManagementDashboard'
import AcCustomerForm from '../acModules/components/customerManangement/CustomerForm/CustomerForm'
import AcChargingStationDashboard from '../acModules/components/chargingStation/AcChargingStationDashboard'
import AcChargingStationForm from '../acModules/components/chargingStation/AcChargingStationForm'
import SetAcParametersDashboard from '../acModules/components/chargers/SetAcParametersDashboard'
import ViewAcParameters from '../acModules/components/chargers/EditParameter/ViewAcParameter'
import EditAcParameter from '../acModules/components/chargers/EditParameter/EditAcParameter'
import AddAcParameter from '../acModules/components/chargers/AddParameter/AddAcParameter'
import UpdateAcCommandsDashboard from '../acModules/components/chargers/UpdateAcCommandsDashboard'
import ViewAcUpdateCommand from '../acModules/components/chargers/UpdateCommands/ViewAcUpdateCommand'
import AcChargerLogsDashboard from '../acModules/components/reports/AcChargerLogsDashboard'
import AcSoftwareReleaseDashboard from '../acModules/components/softwareReleaseManagement/dashboard/AcSoftwareReleaseDashboard'
import AcManageDeploymentLogsDashboard from '../acModules/components/softwareReleaseManagement/deploymentLogs/AcManageDeploymentLogsDashboard'
//import AcManageSoftwareVersionReleasesDashboard from '../acModules/components/softwareReleaseManagement/versionReleases/AcManageSoftwareVersionReleasesDashboard'
//import AddAcSoftwareVersion from '../acModules/components/softwareReleaseManagement/addVersion/AddAcSoftwareVersion'
import AcAlarmPanelDashboard from '../acModules/components/alarms/AlarmPanel/AcAlarmPanelDashboard'
import AddAcCharger from '../acModules/components/chargers/AddCharger/AddAcCharger'
import AcOrgManagementDashboard from '../acModules/components/users/AcOrgManagementDashboard'
import AcOrgForm from '../acModules/components/users/OrgForm/AcOrgForm'
import AcUserManagementDashboard from '../acModules/components/users/AcUserManagementDashboard'
import AcUserForm from '../acModules/components/users/UserForm/AcUserForm'
import DerivedConditionForm from '../components/advanceRuleEngine/DerivedConditionForm'
import DerivedConditionPlan from '../components/advanceRuleEngine/executionPlan/DerivedConditionPlan'
import AcExceptionLogsDashboard from '../acModules/components/reports/AcExceptionLogsDashboard'
// import AcManageSoftwareVersionReleasesDashboard from '../acModules/components/softwareReleaseManagement/versionReleases/AcManageSoftwareVersionReleasesDashboard'
// import AddAcSoftwareVersion from '../acModules/components/softwareReleaseManagement/addVersion/AddAcSoftwareVersion'
import AcNocDashboard from '../acModules/components/nocDashboard/AcNocDashboard'
import AcStatusHistoryDashboard from '../acModules/components/reports/AcStatusHistoryDashboard'
import AcUptimeReportDashboard from '../acModules/components/reports/AcUptimeReportDashboard'
// import AcConfigureNotificationDashboard from '../acModules/components/configureNotification/AcConfigureNotificationDashboard'
// import AcCreateRule from '../acModules/components/configureNotification/AcCreateRule'
import AcManageSoftwareVersionReleasesDashboard from '../acModules/components/softwareReleaseManagement/versionReleases/AcManageSoftwareVersionReleasesDashboard'
import AddAcSoftwareVersion from '../acModules/components/softwareReleaseManagement/addVersion/AddAcSoftwareVersion'
import AcConfigureNotificationDashboard from '../acModules/components/configureNotification/AcConfigureNotificationDashboard'
import AcCreateRule from '../acModules/components/configureNotification/AcCreateRule'
import AcSpuriousChargersDashboard from '../acModules/components/chargers/AcSpuriousChargersDashboard'
import AddAcUpdateCommands from '../acModules/components/chargers/UpdateCommands/AddAcUpdateCommand'
// import AcAlarmsDashboard from '../acModules/components/alarms/AcAlarmDashboard'
// import AcChargerHistoryDashboard from '../acModules/components/reports/AcChargerHistoryDashboard'
// import AcChargerLogsDashboard from '../acModules/components/reports/AcChargerLogsDashboard'


interface RouteProp {
  path: string;
  component: JSX.Element;
  isEnabled: boolean;
  isSideBarEnabled: boolean;
  isNavbarBarEnabled: boolean;
  searchQuery?: string;
  isAccessible?: boolean;
}

export const unAuthenticatedRoutes = (): RouteProp[] => {
  return [
    {
      path: '/',
      component: <LoginScreen key="login" showOtpScreen={false} />,
      isEnabled: true,
      isSideBarEnabled: false,
      isNavbarBarEnabled: false,
      isAccessible: true
    },
    {
      path: '/otp-validation',
      component: <LoginScreen key="otp-validation" showOtpScreen={true} />,
      isEnabled: true,
      isSideBarEnabled: false,
      isNavbarBarEnabled: false,
      isAccessible: true
    },
    {
      path: '*',
      component: <Navigate to="/" replace />,
      isEnabled: true,
      isSideBarEnabled: false,
      isNavbarBarEnabled: false,
      isAccessible: true
    },
  ]
}
// const allowedUsers= ['d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246','345acb60-b2e7-4e83-aa80-c2c70797c76f','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','84c5b1e7-28a7-4fb1-a869-a3f60ee95318', 'a5319a0b-7025-4934-bcac-ba451807d5b2',
//   '7ac346c0-33fd-4fa7-be08-b8465b58e7a9','93b19d88-6799-48aa-ac27-02b4e4fb93f9', 'ca9678e2-52d0-4cf3-a2c8-4dd5727d7d35','e9b21cf0-cc25-4474-a279-04616a0d78f1','f1b61727-2cbf-4a95-9760-be993796489b','2877faa5-6226-45dd-b575-9ef680d87844','fb972809-0dc9-481f-ac7f-167dc7eb0c99'
//   ,'aefdba75-9d7d-4e9d-aab9-86f2944aad46','e59b69f1-0fad-4093-bfa4-cad5a531f3e4'
// ]


//const nocDashboardAccess = ['f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','de227ed8-9e35-4c45-a04d-5af10a6d850f','aefdba75-9d7d-4e9d-aab9-86f2944aad46','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246','e9b21cf0-cc25-4474-a279-04616a0d78f1','5a599f54-93ac-4160-b0e9-887d8827f058']

// const rmsSupportCenterAccess = ['f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','de227ed8-9e35-4c45-a04d-5af10a6d850f','aefdba75-9d7d-4e9d-aab9-86f2944aad46','e9b21cf0-cc25-4474-a279-04616a0d78f1','93b19d88-6799-48aa-ac27-02b4e4fb93f9','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246']


// const softwareReleaseAccess = ['aefdba75-9d7d-4e9d-aab9-86f2944aad46','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7246','f1b61727-2cbf-4a95-9760-be993796489b','d7e6c9b5-f370-46a0-b7e5-26bdc2ae7257','e9b21cf0-cc25-4474-a279-04616a0d78f1']
export const authenticatedRoutes = (): RouteProp[] => {

  return [
    {
      path: '/dashboard',
      component: <Dashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.dashboard?.view() && (!access?.newDashboard?.view() || access?.isSuperAdmin())
    },
    {
      path: '/newDashboard',
      component: <NewDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible:access?.newDashboard?.view()
    },
    {
      path: '/',
      component: (access?.newDashboard?.view() && !access?.isSuperAdmin()) ? <Navigate to="/newDashboard" replace /> : <Navigate to="/dashboard" replace />,
      isEnabled: true,
      isSideBarEnabled: false,
      isNavbarBarEnabled: false,
      isAccessible: access?.dashboard?.view()
    },
    {
      path: '/alarms',
      component: <AlarmManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.alarms?.view()
    },
    {
      path: '/customers',
      component: <CustomerManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.customers?.view()
    },

    {
      path: '/manage-chargers',
      component: <ManageChargersDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargers?.view()
    },

    {
      path: '/charger',
      component: <ChargerPanel />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.view()
    },

    {
      path: '/add-charger',
      component: <AddCharger />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.add()
    },

    {
      path: '/add-bulk-charger',
      component: <AddBulkCharger />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.add()
    },

    {
      path: '/charger-detail',
      component: <AddCharger />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.edit() || access?.chargers?.view()
    },

    {
      path: '/customer',
      component: <CustomerForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.customers?.add() || access?.customers?.edit() || access?.customers?.view()
    },
    {
      path: '/edit-history',
      component: <EditHistory />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.customers?.edit()
    },
    {
      path: '/station-edit-history',
      component: <ChargingStationEditHistory />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargingStation?.edit()
    },

    {
      path: '/alarm',
      component: <AlarmPanelDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'alarmId',
      isAccessible: access?.alarms?.view()
    },

    {
      path: '/add-parameter',
      component: <AddParameter />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.add()
      // searchQuery: 'chargerId'
    },
    {
      path: '/add-command',
      component: <AddUpdateCommand />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.add()
    },
    {
      path: '/edit-command',
      component: <AddUpdateCommand />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.edit()
    },
    {
      path: '/view-command',
      component: <ViewUpdateCommand />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
      // searchQuery: 'chargerId'
    },
    {
      path: '/edit-parameter',
      component: <EditParameter />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.edit()
      // searchQuery: 'chargerId'
    },
    {
      path: '/view-parameter',
      component: <ViewParameter />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
      // searchQuery: 'chargerId'
    },

    {
      path: '/update-settings',
      component: <SetParametersDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
    },
    {
      path: '/update-commands',
      component: <UpdateCommandsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
    },
    { 
      path: '/spurious-chargers',
      component: <SpuriousChargersDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.spuriousCharger?.view()
    },
    { 
      path: '/password-reset-logs',
      component: <ManageAdminPasswordUpdateLogsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
    },


    // {
    //   path: '/broadcast-message',
    //   component: <BroadcastMessageDashboard />,
    //   isEnabled: true,
    //   isSideBarEnabled: true,
    //   isNavbarBarEnabled: true
    // },
    {
      path: '/broadcast-message/create',
      component: <CreateBroadcastMessage />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true
    },
    // {
    //   path: '/broadcast-message/detail',
    //   component: <BroadcastMessageDetail />,
    //   isEnabled: true,
    //   isSideBarEnabled: true,
    //   isNavbarBarEnabled: true
    // },
    {
      path: '/broadcast-message/edit',
      component: <EditBroadcastMessage />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true
    },
    {
      path: '/charging-stations',
      component: <ChargingStationDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargingStation?.view()
    },
    {
      path: '/station',
      component: <ChargingStationForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargingStation?.add() || access?.chargingStation?.edit() || access?.chargingStation?.view()
    },
    {
      path: '/manage-users',
      component: <UserManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.users?.view()
    },
    {
      path: '/user',
      component: <UserForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'userId',
      isAccessible: access?.users?.add() || access?.users?.edit() || access?.users?.view()
    },
    {
      path: '/roles',
      component: <RoleManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.roles?.view()
    },
    {
      path: '/role',
      component: <RoleForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'roleId',
      isAccessible: access?.roles?.view()
    },
    {
      path: '/manage-org',
      component: <OrgManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.organisation?.view()
    },
    {
      path: '/org',
      component: <OrgForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'orgId',
      isAccessible: access?.organisation?.add() || access?.organisation?.view() || access?.organisation?.edit()
    },
    {
      path: '/chargingHistory',
      component: <ChargerHistoryDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.chargingHistory?.view()
    },
    {
      path: '/chargerLogs',
      component: <ChargerLogsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.chargerLog?.status?.view() || access?.reports?.chargerLog?.setting?.view() || access?.reports?.chargerLog?.systemInfo?.view()
    },
    {
      path: '/exceptionLogs',
      component: <ExceptionLogsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.exceptionLogs?.view()
    },
    {
      path: '/sessionHistory',
      component: <SessionHistoryDashboard/>,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.chargingHistory?.view()
    },
    {
      path: '/uptimeReport',
      component: <UptimeReportDashboard/>,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.uptimeReports?.view()
    },
    {
      path: '/inventoryParameterReport',
      component: <InventoryParamReportDashboard/>,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.chargingHistory?.view()
    },
    {
      path: '/configure-plc-logs',
      component: <AddPlcLogConfiguration/>,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.chargingHistory?.view()
    },
    // {
    //   path: '/rule-engine',
    //   component: <RuleEngineDashboard />,
    //   isEnabled: true,
    //   isSideBarEnabled: true,
    //   isNavbarBarEnabled: true,
    //   isAccessible: access?.ruleEngine?.view()
    // },

    {
      path: '/configureNotification',
      component: <ConfigureNotificationDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.configureNotification?.view()
    },
    {
      path: '/create-notification-rule',
      component: <CreateRule />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.configureNotification?.add() || access?.configureNotification?.edit()
    },
    {
      path: '*',
      component: (access?.newDashboard?.view() && !access?.isSuperAdmin()) ? <Navigate to="/newDashboard" replace /> : <Navigate to="/dashboard" replace />,
      isEnabled: true,
      isSideBarEnabled: false,
      isNavbarBarEnabled: false,
      isAccessible: true
    },
    // {
    //   path: '/new-rule',
    //   component: <RuleEngineForm />,
    //   isEnabled: true,
    //   isSideBarEnabled: true,
    //   isNavbarBarEnabled: true,
    //   isAccessible: access?.ruleEngine?.add() || access?.ruleEngine?.edit()
    // },
    // {
    //   path: '/define-execution-plan',
    //   component: <ExecutionPlan />,
    //   isEnabled: true,
    //   isSideBarEnabled: true,
    //   isNavbarBarEnabled: true,
    //   isAccessible: access?.ruleEngine?.add() || access?.ruleEngine?.edit()
    // },
    {
      path: '/usb-certificates',
      component: <UsbCertificates />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.ruleEngine?.add() || access?.ruleEngine?.edit()
    },
    {
      path: '/charger-certificates',
      component: <ChargerCertificatesInfo />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.ruleEngine?.add() || access?.ruleEngine?.edit()
    },
    {
      path: '/add-charger-certificate',
      component: <CreateChargerCertificate />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.ruleEngine?.add() || access?.ruleEngine?.edit()
    },
    {
      path: '/add-usb-certificate',
      component: <CreateUsbCertificate />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargers?.add() || access?.chargers?.edit()
    },
    {
      path:'/manage-software-version-releases',
      component: <ManageSoftwareVersionReleasesDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible: access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
    },
    {
      path:'/add-version-release',
      component:<AddSoftwareVersion/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible: access?.softwareVersionReleases?.addSoftwareVersion?.edit() || access?.softwareVersionReleases?.addSoftwareVersion?.add() || access?.softwareVersionReleases?.addSoftwareVersion?.view()  
    },
    {
      path:'/software-version-release-dashboard',
      component:<SoftwareReleaseDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view()
    },
    {
      path:'/manage-deployment-logs',
      component:<ManageDeploymentLogsDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
    },
    {
      path:'/noc-dashboard',
      component:<NocDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.isSuperAdmin(),

    },
    {
      path:'/rms-support-center',
      component:<RmsSupportAIChatDashboard/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.aiSupportCenter?.aiSupportCenterChatBot?.view(),
      isSideBarEnabled:false
    },
    {
      path:'/rms-support-center/chat',
      component:<RmsSupportAIChatBot/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.aiSupportCenter?.aiSupportCenterChatBot?.view(),
      isSideBarEnabled:false
    },
    {
      path:'/help-and-faq-dashboard',
      component:< HelpAndFAQDashboard/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.aiSupportCenter?.aiSupportCenterChatBot?.view(),
      isSideBarEnabled:false
    },
    {
      path:'/help-and-faq',
      component:<HelpAndFAQTopicsDashboard/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.aiSupportCenter?.aiSupportCenterChatBot?.view(),
      isSideBarEnabled:false,
      searchQuery:'topic'
    },
    {
      path:'/help-and-faq/:topic',
      component:<HelpAndFAQArticle/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.aiSupportCenter?.aiSupportCenterChatBot?.view(),
      isSideBarEnabled:false,
      searchQuery:'article'
    },
    {
      path:'/troubleshooting',
      component:<TroubleShootingDashboard/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isSideBarEnabled:false,
      isAccessible:access?.aiSupportCenter?.aiSupportCenterChatBot?.view()
    },
    {
      path:'/documentation',
      component:<DocumentationDashboard/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isSideBarEnabled:false,
      isAccessible:access?.aiSupportCenter?.documentation?.view(),
    },
    {
      path:'/add-document',
      component:<AddRmsSupportDocuments/>,
      isEnabled:true,
      isNavbarBarEnabled:true,
      isSideBarEnabled:false,
      isAccessible:access?.aiSupportCenter?.documentation?.add() || access?.aiSupportCenter?.documentation?.edit(),
    },
    {
      path:'/status-history',
      component: <StatusHistoryDashboard/>,
      isEnabled: true,
      isNavbarBarEnabled: true,
      isSideBarEnabled: false,
      isAccessible: access?.isSuperAdmin()
    },
    {
      path: '/define-execution-plan-advance',
      component:<AdvanceExecutionPlan/>,
      isEnabled: true,
      isNavbarBarEnabled: true,
      isSideBarEnabled: false,
      isAccessible: access?.advanceRuleEngineAccess?.add() || access?.advanceRuleEngineAccess?.edit()
    },
    {
      path: '/new-rule-advance',
      component: <AdvanceRuleEngineForm/>,
      isEnabled: true,
      isNavbarBarEnabled: true,
      isSideBarEnabled: false,
      isAccessible: access?.advanceRuleEngineAccess?.add() || access?.advanceRuleEngineAccess?.edit()
    },
    {
      path: '/rule-engine-advance',
      component: <AdvanceRuleEngineDashboard/>,
      isEnabled: true,
      isNavbarBarEnabled: true,
      isSideBarEnabled: true,
      isAccessible: access?.advanceRuleEngineAccess?.view()
    },
    {
      path: '/add-derived-condition',
      component: <DerivedConditionForm/>,
      isEnabled: true,
      isNavbarBarEnabled: true,
      isSideBarEnabled: false,
      isAccessible: access?.advanceRuleEngineAccess?.add() || access?.advanceRuleEngineAccess?.edit()
    },
    {
      path: '/define-derived-condition',
      component: <DerivedConditionPlan/>,
      isEnabled: true,
      isNavbarBarEnabled: true,
      isSideBarEnabled: false,
      isAccessible: access?.advanceRuleEngineAccess?.add() || access?.advanceRuleEngineAccess?.edit()
    }
  ]
}

export const authenticatedAcRoutes = (): RouteProp[] => {

  return [
    {
      path: '/ac/dashboard',
      component: <AcDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.dashboard?.view()
    },

    {
      path: '/ac/manage-chargers',
      component: <AcManageChargersDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargers?.view()
    },
    {
      path: '/ac/customers',
      component: <AcCustomerManagementDashboard/>,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.customers?.view()
    },
    {
      path: '/ac/customer',
      component: <AcCustomerForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.customers?.add() || access?.customers?.edit() || access?.customers?.view()
    },
    {
      path: '/ac/charging-stations',
      component: <AcChargingStationDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargingStation?.view()
    },
        {
      path: '/ac/station',
      component: <AcChargingStationForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.chargingStation?.add() || access?.chargingStation?.edit() || access?.chargingStation?.view()
    },
    {
      path: '/ac/alarms',
      component: <AcAlarmsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.alarms?.view()
    },
    {
      path: '/ac/alarm',
      component: <AcAlarmPanelDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'alarmId',
      isAccessible: access?.alarms?.view()
    },
    {
      path: '/ac/charger',
      component: <AcChargerPanel />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.view()
    },

    {
      path: '/ac/add-charger',
      component: <AddAcCharger />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.add()
    },

    {
      path: '/ac/add-bulk-charger',
      component: <AddBulkCharger />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.add()
    },

    {
      path: '/ac/charger-detail',
      component: <AddAcCharger />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'chargerId',
      isAccessible: access?.chargers?.edit() || access?.chargers?.view()
    },
    {
      path: '/ac/update-settings',
      component: <SetAcParametersDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
    },
    {
      path: '/ac/update-commands',
      component: <UpdateAcCommandsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
    },
    {
      path: '/ac/view-command',
      component: <ViewAcUpdateCommand />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
      // searchQuery: 'chargerId'
    },
    {
      path: '/ac/view-parameter',
      component: <ViewAcParameters />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.view()
      // searchQuery: 'chargerId'
    },

    {
      path:'/ac/noc-dashboard',
      component:<AcNocDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.isSuperAdmin(),

    },
    {
      path: '/ac/add-parameter',
      component: <AddAcParameter />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.add()
      // searchQuery: 'chargerId'
    },
    {
      path: '/ac/add-command',
      component: <AddAcUpdateCommands />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.add()
    },
    {
      path: '/ac/edit-parameter',
      component: < EditAcParameter/>,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.updateSetting?.edit()
      // searchQuery: 'chargerId'
    },
    {
      path: '/ac/chargingHistory',
      component: <AcChargerHistoryDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.chargingHistory?.view()
    },
    {
      path:'/ac/software-version-release-dashboard',
      component:<AcSoftwareReleaseDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view()
    },
    {
      path:'/ac/manage-deployment-logs',
      component:<AcManageDeploymentLogsDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible:access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
    },
    {
      path: '/ac/manage-org',
      component: <AcOrgManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.organisation?.view()
    },
    {
      path: '/ac/manage-users',
      component: <AcUserManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.users?.view()
    },
        {
      path: '/ac/org',
      component: <AcOrgForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'orgId',
      isAccessible: access?.organisation?.add() || access?.organisation?.view() || access?.organisation?.edit()
    },
        {
      path: '/ac/user',
      component: <AcUserForm />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      searchQuery: 'userId',
      isAccessible: access?.users?.add() || access?.users?.edit() || access?.users?.view()
    },
    {
      path: '/ac/roles',
      component: <RoleManagementDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.roles?.view()
    },
    {
    path: '/',
    component: <Navigate to="/ac/dashboard" replace />,
    isEnabled: true,
    isSideBarEnabled: false,
    isNavbarBarEnabled: false,
    isAccessible: true
   },
    // {
    //   path: '/ac/sessionHistory',
    //   component: <AcSessionHistoryDashboard/>,
    //   isEnabled: true,
    //   isSideBarEnabled: true,
    //   isNavbarBarEnabled: true,
    //   isAccessible: access?.reports?.chargingHistory?.view()
    // },
    {
      path: '/ac/chargerLogs',
      component: <AcChargerLogsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.chargerLog?.status?.view() || access?.reports?.chargerLog?.setting?.view() || access?.reports?.chargerLog?.systemInfo?.view()
    },
    {
      path:'/ac/manage-software-version-releases',
      component: <AcManageSoftwareVersionReleasesDashboard/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible: access?.softwareVersionReleases?.softwareReleaseDashboard?.view(),
    },
        {
      path:'/ac/add-version-release',
      component:<AddAcSoftwareVersion/>,
      isEnabled:true,
      isSideBarEnabled:true,
      isNavbarBarEnabled:true,
      isAccessible: access?.softwareVersionReleases?.addSoftwareVersion?.edit() || access?.softwareVersionReleases?.addSoftwareVersion?.add() || access?.softwareVersionReleases?.addSoftwareVersion?.view()  
    },
    {
      path: '/ac/exceptionLogs',
      component: <AcExceptionLogsDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.reports?.exceptionLogs?.view()
    },
    // {
    //   path: '/ac/uptimeReport',
    //   component: <AcUptimeReportDashboard/>,
    //   isEnabled: true,
    //   isSideBarEnabled: true,
    //   isNavbarBarEnabled: true,
    //   isAccessible: access?.reports?.uptimeReports?.view()
    // },
    {
      path: '/ac/configure-notification',
      component: <AcConfigureNotificationDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.configureNotification?.view()
    },
    {
      path: '/ac/create-notification-rule',
      component: <AcCreateRule />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.configureNotification?.add() || access?.configureNotification?.edit() || access?.configureNotification?.view()
    },
    {
      path: '/ac/status-history',
      component: <AcStatusHistoryDashboard />,
      isEnabled: true,
      isNavbarBarEnabled: true,
      isSideBarEnabled: false,
      isAccessible: access?.isSuperAdmin()
    },
    {
      path: '/ac/uptime-report',
      component: <AcUptimeReportDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: true
    },
    {
      path: '/ac/spurious-chargers',
      component: <AcSpuriousChargersDashboard />,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: access?.spuriousCharger?.view()
    },
    {
      path: '/ac/charger-certificates',
      component: <AcChargerCertificatesInfo/>,
      isEnabled: true,
      isSideBarEnabled: true,
      isNavbarBarEnabled: true,
      isAccessible: true
    },
    {
      path: '/ac/add-charger-certificate',
      component: <CreateAcChargerCertificate/>,
      isEnabled: true,
      isSideBarEnabled: false,
      isNavbarBarEnabled: true,
      isAccessible: true
    },
    {
      path: '*',
      component: <Navigate to="/ac/dashboard" replace />,
      isEnabled: true,
      isSideBarEnabled: false,
      isNavbarBarEnabled: false,
      isAccessible: true
    },
  ]
}

export default { authenticatedRoutes, unAuthenticatedRoutes ,authenticatedAcRoutes}

